/* 首页 */
export class HomeModel {
  /*
      type
      1--main_banner--首页主banner
      2--sports_club_banner--运动家俱乐部banner
      3--course_recommendation--首页课程推荐
     */
  constructor(form, type = 1) {
    const keyMap = {
      1: "main_banner",
      2: "sports_club_banner",
      3: "course_recommendation",
      4: "course_index_banner",
      5: "series_task_activity_index_new",
    };
    this.id = form?.id || "";
    this.key = keyMap[type] || "main_banner";
    this.segment = "home_page_module";
    switch (type) {
      case 1:
        this.initType1(form);
        break;
      case 2:
        this.initType2(form);
        break;
      case 3:
        this.initType3(form);
        break;
      case 4:
        this.initType4(form);
        break;
      case 5:
        this.initType5(form);
        break;
      default:
        break;
    }
  }

  initType1(form) {
    if (form) {
      this.value = form.value;
    } else {
      this.clearType1();
    }
  }

  initType2(form) {
    if (form) {
      this.value = form.value;
    } else {
      this.clearType2();
    }
  }

  initType3(form) {
    if (form) {
      this.value = form.value;
    } else {
      this.clearType3();
    }
  }
  initType4(form) {
    if (form) {
      if (form.value.length) {
        this.value = form.value;
      } else {
        this.clearType4();
      }
    } else {
      this.clearType4();
    }
  }
  initType5(form) {
    if (form) {
      if (form.value.length) {
        this.value = form.value;
        this.value[0].time = [form.value[0].beginTime, form.value[0].endTime];
      } else {
        this.clearType5();
      }
    } else {
      this.clearType5();
    }
  }

  clearType1() {
    this.value = [];
  }

  clearType2() {
    this.value = [
      {
        imageUrl: '',
        titleList: ['', ''],
        subTitle: '',
        linkUrl: '',
        visibleUserLevel: 0,
        levelCopyrighting: '',
      },
      {
        imageUrl: '',
        titleList: ['', ''],
        subTitle: '',
        linkUrl: '',
        visibleUserLevel: 0,
        levelCopyrighting: '',
      },
      {
        imageUrl: '',
        titleList: ['', ''],
        subTitle: '',
        linkUrl: '',
        visibleUserLevel: 0,
        levelCopyrighting: '',
      },
      {
        imageUrl: '',
        titleList: ['', ''],
        subTitle: '',
        linkUrl: '',
        visibleUserLevel: 0,
        levelCopyrighting: '',
      },
    ];
  }

  clearType3() {
    this.value = [];
  }
  clearType4() {
    this.value = [];
  }
  clearType5() {
    this.value = [];
  }
}

/* 课程/活动频道 */
export class ClassEvents {
  constructor(form) {
    this.id = form?.id || "";
    this.key = "course_activity_channel";
    this.segment = "course_activity";
    if (form) {
      this.value = form.value;
    } else {
      this.clear();
    }
  }
  clear() {
    this.value = [
      {
        imageUrl: '',
        linkUrl: '',
        visibleUserLevel: 0,
        fpVisible: null,
      },
      {
        imageUrl: '',
        linkUrl: '',
        visibleUserLevel: 0,
        fpVisible: null,
      },
      {
        imageUrl: '',
        linkUrl: '',
        visibleUserLevel: 0,
        fpVisible: null,
      },
    ];
  }
}

/* 积分兑换频道 */
export class IntegralExchange {
  constructor(form) {
    this.id = form?.id || "";
    this.key = "integral_exchange_channel";
    this.segment = "integral_exchange";
    if (form) {
      this.value = form.value;
    } else {
      this.clear();
    }
  }
  clear() {
    this.value = [
      {
        imageUrl: '',
        linkUrl: '',
      },
    ];
  }
}
